import React from "react";

/**
 * Subtle calypso-blue divider for separating dark sections of the same color.
 * Variant "line" = thin gradient line. Variant "dot" = line with center accent dot.
 */
export default function SectionDivider({ variant = "line", bg = "#0B0B0B" }) {
  if (variant === "dot") {
    return (
      <div
        aria-hidden="true"
        className="relative w-full"
        style={{ background: bg }}
        data-testid="section-divider"
      >
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-1 sm:py-2">
          <div className="relative flex items-center justify-center">
            <span className="h-px flex-1 bg-gradient-to-r from-transparent to-[#5FBDD6]/40" />
            <span
              className="mx-3 h-1.5 w-1.5 rounded-full"
              style={{ background: "#5FBDD6" }}
            />
            <span className="h-px flex-1 bg-gradient-to-l from-transparent to-[#5FBDD6]/40" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      aria-hidden="true"
      className="w-full"
      style={{ background: bg }}
      data-testid="section-divider"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="h-px w-full bg-gradient-to-r from-transparent via-[#5FBDD6]/40 to-transparent" />
      </div>
    </div>
  );
}
